import React, { useState } from "react";

const Password = ({ onClose, onSuccess }) => {
    const [password, setPassword] = useState("");

    const correctPassword = process.env.REACT_APP_UPLOAD_PASSWORD;

    const handleSubmit = (e) => {
        e.preventDefault();
        if (password === correctPassword) {
            onSuccess();
            onClose();
            setPassword("");
        } else {
            alert("비밀번호가 틀렸습니다.");
        }
    };

    return (
        <div className="flex flex-col gap-4 items-center p-6 pt-9 rounded-lg shadow-lg w-[320px] relative">
            <h2 className="text-xl font-bold mb-2">비밀번호 입력</h2>
            <form onSubmit={handleSubmit} className="w-full flex flex-col gap-3">
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full p-2 rounded bg-white border border-gray-300"
                    placeholder="비밀번호"
                    autoFocus
                />
                <button
                    type="submit"
                    className="w-full bg-blue-400 hover:bg-blue-500 text-white 0 py-2 rounded font-semibold"
                >
                    확인
                </button>
            </form>
        </div>
    );
};

export default Password;
